{
  "name": "recit_workplan",
  "version": "3.0.0-stable",
  "description": "RÉCIT Work Plan",
   "targets": {
        "default": {
            "publicUrl": "./",
            "distDir": "build"
        }
    },
  "scripts": {
    "test": "echo \"Error: no test specified\" && exit 1",
    "start": "parcel ./src/index.js --dist-dir ./build",
    "build": "parcel build ./src/index.js"
  },
  "keywords": [],
  "author": "",
  "license": "ISC",
  "dependencies": {
    "@fortawesome/fontawesome-svg-core": "7.2.0",
    "@fortawesome/free-solid-svg-icons": "7.2.0",
    "@fortawesome/react-fontawesome": "3.2.0",
    "bootstrap": "5.3.8",
    "date-fns": "4.1.0",
    "react": "19.2.4",
    "react-bootstrap": "2.10.10",
    "react-dom": "19.2.4",
    "react-quill-new": "3.8.3",
    "react-select": "5.10.2"
  },
  "devDependencies": {
    "@parcel/transformer-sass": "2.16.4",
    "parcel": "2.16.4",
    "sass": "1.97.3"
  }
}
